import { createContext, useContext, useCallback } from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import { ROUTES } from '../constants/routes';
import { usePreviewContext } from './usePreviewContext';
import { jsx as _jsx } from "react/jsx-runtime";
const NavigationContext = /*#__PURE__*/createContext(null);
export function NavigationProvider({
  children
}) {
  const history = useHistory();
  const {
    search: previewSearch,
    hash: previewHash
  } = usePreviewContext();
  const toListings = useCallback(() => {
    history.push({
      pathname: ROUTES.root,
      search: previewSearch,
      hash: previewHash
    });
  }, [history, previewSearch, previewHash]);
  const toNewTicket = useCallback(() => {
    history.push({
      pathname: ROUTES.new,
      search: previewSearch,
      hash: previewHash
    });
  }, [history, previewSearch, previewHash]);
  const toTicketDetails = useCallback((ticketId, threadId) => {
    history.push({
      pathname: generatePath(ROUTES.ticket, {
        ticketId,
        threadId
      }),
      search: previewSearch,
      hash: previewHash
    });
  }, [history, previewSearch, previewHash]);
  return /*#__PURE__*/_jsx(NavigationContext.Provider, {
    value: {
      toListings,
      toNewTicket,
      toTicketDetails
    },
    children: children
  });
}
export function useNavigationContext() {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigationContext must be used within a NavigationProvider');
  }
  return context;
}